export default "__VITE_ASSET__J9OvVKa2__"